/**
 * Use Case: Deletar Usuário
 * Orquestra a lógica de negócio para exclusão de usuários
 * Segue o princípio de Responsabilidade Única (SOLID)
 */

import { IUserRepository } from '../../../domain/repositories/IUserRepository';

export class DeleteUserUseCase {
    constructor(private readonly userRepository: IUserRepository) { }

    async execute(userId: string): Promise<void> {
        // 1. Busca o usuário
        const user = await this.userRepository.findById(userId);

        if (!user) {
            return;
        }

        // 2. Valida regras de negócio
        if (user.isAdmin()) {
            const adminCount = await this.userRepository.countAdmins();

            if (adminCount <= 1) {
                throw new Error('Não é possível deletar o único administrador do sistema');
            }
        }

        if (!user.canDelete()) {
            throw new Error('Este usuário não pode ser deletado');
        }

        // 3. Executa a exclusão
        await this.userRepository.delete(userId);
    }
}
